/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type OrganisationPublicServicesBox_OrganisationProfileFragment = { __typename: 'OrganisationProfile', id: string, slug: string, categories: Array<string>, organisation: { __typename: 'Organisation', id: string } };

export const OrganisationPublicServicesBox_OrganisationProfileFragmentDoc = gql`
    fragment OrganisationPublicServicesBox_OrganisationProfile on OrganisationProfile {
  id
  slug
  categories
  organisation {
    id
  }
}
    `;